import styled from "@emotion/styled";

export const Container = styled.div`
  z-index: 100;
  display: flex;
  width: 280px;
  flex-direction: column;
  position: absolute;
  top: 38px;
  left: 0px;
`;

export const SelectedContainer = styled.div`
  display: flex;
  align-self: stretch;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  padding: 8px 12px;
  min-height: 40px;

  box-sizing: border-box;
  gap: 4px;
  overflow-x: auto;
  border-bottom: 1px solid var(--alias-color-line-normal);
  background-color: var(--alias-color-background-normal-alternative);
  box-shadow: var(--alias-style-shadow-strong);

  ::-webkit-scrollbar {
    background-color: transparent;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: var(--component-color-fill-strong);
  }
`;

export const DropdownContainer = styled.div`
  display: flex;
`;
